<route>
{
    "name": "admin-users-and-roles-index",
    "meta": {
        "title": "Operatori si permisiuni",
        "requiresAuth": true,
        "permission": "guest",
        "fail": "/404"
    }
}
</route>
<template>
    <company-layout>
        <v-container fluid grid-list-xl>
            <v-row>
                <v-col cols="12">
                    <users-index></users-index>
                </v-col>
                <v-col cols="12" class="mt-5">
                    <roles-index></roles-index>
                </v-col>
            </v-row>
        </v-container>
    </company-layout>
</template>

<script>
    import CompanyLayout from "Layouts/Company.vue";
    import UsersIndex from 'Components/users-and-roles/UsersIndex'
    import RolesIndex from 'Components/users-and-roles/RolesIndex'

    export default {
        components: {
            CompanyLayout,
            UsersIndex,
            RolesIndex
        }
    };
</script>
